import React, { useState, useEffect } from 'react';

const ProductPortfolio = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeCategory, setActiveCategory] = useState('spring');
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const categories = [
    { id: 'spring', name: 'Spring Statues & Ornaments', imageCount: 10 },
    { id: 'garden', name: 'Garden Statues & Ornaments', imageCount: 11 },
    { id: 'solar', name: 'Solar Highland Statues & Ornaments', imageCount: 2 },
    { id: 'birdbaths', name: 'Birdbaths', imageCount: 4 },
    { id: 'halloween', name: 'Halloween Statues & Ornaments', imageCount: 10 },
  ];

  const productImages = {
    spring: Array.from({ length: 10 }, (_, i) => `/img/products/spring/spring${i + 1}.png`),
    garden: Array.from({ length: 11 }, (_, i) => `/img/products/garden/garden${i + 1}.png`),
    solar: Array.from({ length: 2 }, (_, i) => `/img/products/solar/solar${i + 1}.png`),
    birdbaths: Array.from({ length: 4 }, (_, i) => `/img/products/birdbaths/birdbath${i + 1}.png`),
    halloween: Array.from({ length: 10 }, (_, i) => `/img/products/halloween/halloween${i + 1}.png`),
  };

  const manufacturingCapabilities = [
    {
      id: 'blowmolding',
      title: 'PRODUCT - BLOW MOLDING',
      machines: ['55 Type machine', '75 Type machine', '90 Type machine'],
      output: '15000PCS - 20000PCS',
      imageCount: 4,
      images: Array.from({ length: 4 }, (_, i) => `/img/manufacturing/blowmolding/blow${i + 1}.png`),
    },
    {
      id: 'polish',
      title: 'PRODUCT POLISH',
      machines: ['Six set stand polishing machine', 'Hand polishing machine according produce to add', 'Over forty workers'],
      output: '15000PCS / Per day',
      imageCount: 2,
      images: Array.from({ length: 2 }, (_, i) => `/img/manufacturing/polish/polish${i + 1}.png`),
    },
    {
      id: 'cement',
      title: 'PRODUCT - CEMENT REFILLING',
      machines: ['80 workers', '6 SETS CEMENT MIXING MACHINE'],
      output: '10000PCS / PER DAY',
      imageCount: 2,
      images: Array.from({ length: 2 }, (_, i) => `/img/manufacturing/cement/cement${i + 1}.png`),
    },
    {
      id: 'painting',
      title: 'PRODUCT PAINTING',
      machines: ['OVER 350 WORKS AT PEAK SEASON', 'HAND PAINTED'],
      output: '10000 PCS / PER DAY',
      imageCount: 4,
      images: Array.from({ length: 4 }, (_, i) => `/img/manufacturing/painting/paint${i + 1}.png`),
    },
    {
      id: 'packing',
      title: 'PRODUCT PACKING',
      machines: ['60 WORKS AT PEAK SEASON'],
      output: 'OVER 10000 PCS / PER DAY',
      imageCount: 2,
      images: Array.from({ length: 2 }, (_, i) => `/img/manufacturing/packing/pack${i + 1}.png`),
    },
  ];

  const features = [
    'High Density Resin',
    'Weather Resistant',
    'Hand Painted',
    'Outdoor and indoor use',
    'Whimsical, eye catching addition to the yard, garden deck or poolside'
  ];

  const currentImages = productImages[activeCategory] || [];
  const currentCategory = categories.find(c => c.id === activeCategory);

  const imageRows = [];
  for (let i = 0; i < currentImages.length; i += 5) {
    imageRows.push(currentImages.slice(i, i + 5));
  }

  const goToPreviousImage = () => {
    const currentIndex = currentImages.findIndex(img => img === selectedImage);
    const prevIndex = currentIndex === 0 ? currentImages.length - 1 : currentIndex - 1;
    setSelectedImage(currentImages[prevIndex]);
  };

  const goToNextImage = () => {
    const currentIndex = currentImages.findIndex(img => img === selectedImage);
    const nextIndex = currentIndex === currentImages.length - 1 ? 0 : currentIndex + 1;
    setSelectedImage(currentImages[nextIndex]);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (selectedImage) {
        if (e.key === 'ArrowLeft') {
          goToPreviousImage();
        } else if (e.key === 'ArrowRight') {
          goToNextImage();
        } else if (e.key === 'Escape') {
          setSelectedImage(null);
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage, currentImages]);

  const getManufacturingImageRows = (images) => {
    const rows = [];
    for (let i = 0; i < images.length; i += 5) {
      rows.push(images.slice(i, i + 5));
    }
    return rows;
  };

  return (
    <section id="portfolio" className="bg-gray-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="text-sm font-semibold text-[#215f9a] uppercase tracking-wider">Our Collection</span>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mt-2 mb-4">
            PRODUCT PORTFOLIO
          </h1>
          <div className="w-16 h-1 bg-[#215f9a] mx-auto"></div>
        </div>

        {/* PRODUCTS GALLERY SECTION */}
        <div className="mb-20">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
              Products Gallery
            </h2>
            <div className="w-16 h-0.5 bg-[#215f9a] mx-auto mt-2"></div>
          </div>

          {/* Category Tabs */}
          <div className="flex flex-wrap justify-center gap-2 mb-10">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`px-5 py-2 text-sm font-medium transition-all duration-200 rounded-md ${
                  activeCategory === category.id
                    ? 'bg-[#215f9a] text-white shadow-md'
                    : 'bg-white text-gray-600 hover:bg-gray-100 border border-gray-200'
                }`}
              >
                {category.name}
                <span className="ml-1 text-xs opacity-80">({category.imageCount})</span>
              </button>
            ))}
          </div>

          {/* Features Section */}
          <div className="bg-white rounded-lg p-6 mb-10 shadow-sm border border-gray-100">
            <h3 className="text-lg font-semibold text-center mb-4 text-gray-900">
              Features
            </h3>
            <div className="flex flex-wrap justify-center gap-4">
              {features.map((feature, idx) => (
                <div key={idx} className="flex items-center gap-2">
                  <svg className="w-4 h-4 text-[#215f9a]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-600 text-sm">{feature}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Category Title */}
          <div className="text-center mb-8">
            <h3 className="text-xl md:text-2xl font-bold text-gray-900">
              {currentCategory?.name}
            </h3>
            <p className="text-gray-500 text-sm mt-1">
              {currentImages.length} Products Available
            </p>
          </div>

          {/* Image Gallery */}
          {imageRows.map((row, rowIndex) => (
            <div key={rowIndex} className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-6">
              {row.map((image, imgIndex) => (
                <div
                  key={imgIndex}
                  onClick={() => setSelectedImage(image)}
                  className="group cursor-pointer bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all duration-200"
                >
                  <div className="relative bg-gray-100" style={{ paddingBottom: '100%' }}>
                    <img
                      src={image}
                      alt={`${currentCategory?.name} ${rowIndex * 5 + imgIndex + 1}`}
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                      onError={(e) => {
                        e.target.src = 'https://placehold.co/400x400/e2e8f0/64748b?text=Product';
                      }}
                    />
                  </div>
                  <div className="p-2 text-center border-t border-gray-100">
                    <p className="text-xs text-gray-500">
                      Product {rowIndex * 5 + imgIndex + 1}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>

        {/* MANUFACTURING CAPABILITIES SECTION */}
        <div>
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
              Manufacturing Capabilities
            </h2>
            <div className="w-16 h-0.5 bg-[#215f9a] mx-auto mt-2"></div>
            <p className="text-gray-500 text-sm mt-3">
              State-of-the-art manufacturing facilities and processes
            </p>
          </div>

          {manufacturingCapabilities.map((capability, idx) => {
            const imageRows = getManufacturingImageRows(capability.images);
            return (
              <div key={capability.id} className="mb-16 last:mb-0 bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
                <div className="p-6 border-b border-gray-100">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-lg bg-[#215f9a] flex items-center justify-center">
                      <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                      </svg>
                    </div>
                    <h3 className="text-lg md:text-xl font-bold text-gray-900">
                      {capability.title}
                    </h3>
                  </div>
                  
                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <h4 className="text-sm font-semibold text-gray-700 mb-2">Equipment & Workforce</h4>
                      <ul className="space-y-1">
                        {capability.machines.map((machine, i) => (
                          <li key={i} className="flex items-center gap-2 text-gray-600 text-sm">
                            <svg className="w-3 h-3 text-[#215f9a]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            {machine}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-gray-700 mb-2">Output Capacity</h4>
                      <div className="flex items-center gap-2 text-gray-600 text-sm">
                        <svg className="w-4 h-4 text-[#215f9a]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                        </svg>
                        <span className="font-medium">{capability.output}</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Manufacturing Images Grid */}
                <div className="p-6 bg-gray-50">
                  {imageRows.map((row, rowIndex) => (
                    <div key={rowIndex} className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-4 last:mb-0">
                      {row.map((image, imgIndex) => (
                        <div
                          key={imgIndex}
                          onClick={() => setSelectedImage(image)}
                          className="group cursor-pointer bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all duration-200"
                        >
                          <div className="relative bg-gray-100" style={{ paddingBottom: '100%' }}>
                            <img
                              src={image}
                              alt={`${capability.title} ${rowIndex * 5 + imgIndex + 1}`}
                              className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                              onError={(e) => {
                                e.target.src = 'https://placehold.co/400x400/e2e8f0/64748b?text=Manufacturing';
                              }}
                            />
                          </div>
                          <div className="p-2 text-center border-t border-gray-100">
                            <p className="text-xs text-gray-500">
                              Image {rowIndex * 5 + imgIndex + 1}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Full Screen Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-white text-2xl hover:text-gray-300 transition-colors z-10 w-10 h-10 flex items-center justify-center"
            onClick={() => setSelectedImage(null)}
          >
            ✕
          </button>

          <button
            className="absolute left-4 text-white text-3xl hover:text-gray-300 transition-colors z-10 bg-black/50 hover:bg-black/75 w-12 h-12 flex items-center justify-center rounded-full"
            onClick={(e) => {
              e.stopPropagation();
              goToPreviousImage();
            }}
          >
            ‹
          </button>

          <button
            className="absolute right-4 text-white text-3xl hover:text-gray-300 transition-colors z-10 bg-black/50 hover:bg-black/75 w-12 h-12 flex items-center justify-center rounded-full"
            onClick={(e) => {
              e.stopPropagation();
              goToNextImage();
            }}
          >
            ›
          </button>

          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-black/75 px-4 py-1.5 rounded-full z-10">
            <span className="text-white text-sm">
              {currentImages.findIndex(img => img === selectedImage) + 1} / {currentImages.length}
            </span>
          </div>

          <div 
            className="relative max-w-[90vw] max-h-[90vh] w-full h-full flex items-center justify-center cursor-pointer"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedImage}
              alt="Preview"
              className="max-w-full max-h-full w-auto h-auto object-contain"
            />
          </div>

          <div className="absolute top-4 left-4 bg-black/75 px-3 py-1.5 rounded-full z-10">
            <span className="text-white text-xs">
              {currentCategory?.name || 'Manufacturing'}
            </span>
          </div>
        </div>
      )}
    </section>
  );
};

export default ProductPortfolio;